import { browserHelpers } from '@approvalmax/utils';
import * as common from 'modules/common';
import { State } from 'modules/data';
import { CompanyUserStatus } from 'modules/data/domain';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { notificationService } from 'services/notification';
import { routingService } from 'services/routing';
import { useGetInvitations } from 'shared/data/webApp/v2';

import { messages } from './useAcceptInvitationPageData.messages';

const useAcceptInvitationPageData = () => {
    const { companyId } = useParams<{ companyId: string }>();

    const [isLoading, setIsLoading] = useState(true);

    const { data } = useGetInvitations();
    const company = useSelector((state: State) => common.selectors.company.findCompanyById(state, companyId));
    const user = useSelector(common.selectors.profile.findProfileUser);
    const userInCompany = useSelector((state: State) =>
        company && user ? common.selectors.company.findCompanyMemberById(state, company, user.id) : null
    );

    const isUserInCompanyActive = userInCompany?.status === CompanyUserStatus.Active;
    const isMobile = browserHelpers.isMobile();

    useEffect(() => {
        if (!data) return;

        if (isMobile || data.items.length > 0) {
            setIsLoading(false);
        } else {
            if (isUserInCompanyActive) {
                notificationService.showInfoToast(messages.alreadyAccepted);
            } else {
                notificationService.showErrorToast(messages.invitationNotFound);
            }

            routingService.replaceToDefaultPath();
        }
    }, [data, isMobile, isUserInCompanyActive]);

    return {
        isLoading,
    };
};

export default useAcceptInvitationPageData;
